<div class="menuCell" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave()" (click)="onItemTap($event)">
    <div class="menu-content" [class.has-icon]="item?.icon" (click)="!item?.subMenu?.length && hide(item)">
        <!-- Main icon -->
        <ng-container *ngIf="item?.icon">
            <img [src]="item?.icon" class="initial-icon" style="width: 25px; height: 25px" />
        </ng-container>

        <!-- Bread icon if submenu -->
        <ng-container *ngIf="item?.subMenu?.length">
            <img src="../../assets/images/bread.svg" class="bread-icon" />
        </ng-container>

        <!-- Text -->
        <div class="menu-text">{{ item?.name }}</div>
    </div>

    <!-- Submenu -->
    <div class="hover-content" [class.open-up]="subMenuShouldOpenUp"
        [class.mobile-open]="isOpen && commonService.isMobileDevice"
        *ngIf="item?.subMenu?.length && (isHovered || isOpen)">
        <ng-container *ngFor="let sub of item.subMenu">
            <div class="submenu-leaf" *ngIf="!sub.subMenu?.length" (click)="hide(sub)">
                {{ sub?.name }}
            </div>

            <app-menu-item *ngIf="sub.subMenu?.length" [item]="sub"></app-menu-item>
        </ng-container>
    </div>
</div>